import { ICreatorTheme } from "../../../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    container: {
      position: "relative",
      overflow: "hidden",
      marginBottom: "8px",
    },
    lockedImg: {
      width: "100%",
    },
    innerContainer: {
      width: "60%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      textAlign: "center",
    },
    paidIcon: {
      width: "32px",
    },
    paidText: {
      fontWeight: "500",
      fontSize: "18px",
    },
    paidDesc: {
      color: "#000000B2",
      fontSize: "14px",
      fontWeight: "400",
    },
    upgradeContainer: {
      backgroundColor: "#166CD1",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      gap: "4px",
      padding: "8px 24px",
      cursor: "pointer",
      borderRadius: "4px",
    },
    upgradeText: {
      fontSize: "16px",
      fontWeight: "600",
    },
  },
  componentName: "LockedImagePost",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const colors = getColorsFromCreatorTheme(theme);
  return getStylesObjFromCss({
    styles: {
      upgradeContainer: {
        backgroundColor: colors.color1 || "#166CD1",
      },
    },
    componentName: "LockedImagePost",
  });
};
